<template>
  <div :class="'d-inline-block total-star-wrapper' + (small ? ' small-version' : '')">
    <div class="total-rating-flag d-inline-block">
      <div class="value">
        {{ totalValue === 0 ? '-' : totalValue }}
      </div>
      <div class="text">
        {{ $t('view-Nativestars.rating') }}
      </div>
    </div>
    <div class="stars d-inline-block">
      <span v-if="!total || total === 0">
        {{ $t('view-Nativestars.not-scored') }}
      </span>
      <div
        v-else
        class="d-inline-block"
      >
        <img
          :src="`${$publicPath}img/stars/total-${total}.svg`"
          class="img-fluid"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 0
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    totalValue () {
      const total = parseInt(this.total || 0)
      let value = total / 2
      value = Math.round(value * 10) / 10
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
  .total-label {
    font-weight: 700;
    font-size: 0.9375rem;
    text-transform: uppercase;
  }

  .total-star-wrapper {
    background: #DF1F5A;
    box-shadow: 1px 2px 7px rgba(0, 0, 0, 0.05);
    border-radius: 12px;
    position: relative;
  }
  .total-rating-flag {
    background: #FCD106;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    text-align: center;
    padding: 0.5rem 0.325rem;
    position: absolute;
    top: -0.325rem;
    left: 1.3125rem;
    .value {
      text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.35);
      font-style: normal;
      font-weight: bold;
      font-size: 1.0625rem;
      line-height: 170%;
      color: white;
    }
    .text {
      font-weight: 600;
      font-size: 0.4375rem;
      line-height: 170%;
      text-transform: uppercase;
    }
  }
  .stars {
    padding-right: 1.5rem;
    padding-left: 4.5rem;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    color: white;
    text-transform: uppercase;
    font-size: 0.85rem;
    font-weight: 700;
    text-align: center;
  }
  .small-version {
    width: 100%;
    .total-rating-flag {
      padding: 0.4rem 0.325rem;
      top: -0.325rem;
      left: 1rem;
      .value {
        font-size: 1rem;
        line-height: 150%;
      }
    }
    .stars {
      font-size: 0.6rem;
      padding-left: 3.9rem;
      padding-right: .9rem;
      width: 100%;
    }
  }
</style>
